var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{staticClass:"card"},[_c('v-card-text',{staticClass:"pa-2"},[_c('pie-chart',{attrs:{"data":_vm.items,"legend":"right","donut":true,"label":"Total Inspections Completed Per Venue"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }